// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import './polyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'

import Core from './core'
window.Core = Core

import Mantle from './perfoplanning/core'
import router from './perfoplanning/router/index'
//import Mantle from './redbox/core'
//import router from './redbox/router/index'
//import Mantle from './ticketnation/core'
//import router from './ticketnation/router/index'

window.Mantle = Mantle

Vue.use(require('vue-moment'));
Vue.use(BootstrapVue)

router.beforeEach((to, from, next) => {
  if (!window.Core.Session.AuthUser.isAuth() && to.meta !== undefined && to.meta.caps !== undefined) {
    next(window.Core.Definition.getDefinition('/connexion'))
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  mounted() {
  }
})
